export function substituteDogName(text: string, dogName: string): string {
  return text.replace(/\{dog_name\}/g, dogName)
}
